import $ from 'jquery'
document.addEventListener('DOMContentLoaded', () => {
  $('form').on('cocoon:after-remove', (e, elem) => {
    if ($(elem.context).siblings("[id$=discarded_at]")) {
      $(elem.context).siblings("[id$=_destroy]").val(false)
      $(elem.context).siblings("[id$=discarded_at]").val(new Date(Date.now()))
    }
  })
})
